import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ isAuthenticated, ...props }) => (
  <svg viewBox="0 0 160.057 60.234" {...props}>
    <defs>
      <linearGradient
        id="prefix__linear-gradient-4"
        x1={-377.284}
        y1={116.466}
        x2={-376.283}
        y2={116.466}
        gradientTransform="translate(1509.341 -433.94) scale(3.95005)"
        xlinkHref="#prefix__linear-gradient-3"
      />
      <linearGradient
        id="prefix__linear-gradient-2"
        x1={-377.284}
        y1={116.466}
        x2={-376.283}
        y2={116.466}
        gradientTransform="translate(1509.341 -433.94) scale(3.95005)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#191919" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient"
        x1={-377.284}
        y1={116.468}
        x2={-376.284}
        y2={116.468}
        gradientTransform="translate(1453.908 -420.347) scale(3.83327)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#191919" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-3"
        x1={-377.284}
        y1={116.468}
        x2={-376.284}
        y2={116.468}
        gradientTransform="translate(1453.908 -420.347) scale(3.83327)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f5a800" />
        <stop offset={1} stopColor="#f5a800" />
      </linearGradient>
      <clipPath id="prefix__clip-path">
        <path className="prefix__cls-4" d="M7.55 22.331h3.953v7.551H7.55z" />
      </clipPath>
      <clipPath id="prefix__clip-path-2">
        <path className="prefix__cls-4" d="M7.551 22.332h3.953v7.55H7.551z" />
      </clipPath>
      <clipPath id="prefix__clip-path-5">
        <path className="prefix__cls-4" d="M19.052 22.331h3.952v7.55h-3.952z" />
      </clipPath>
      <clipPath id="prefix__clip-path-6">
        <path className="prefix__cls-4" d="M19.053 22.332h3.952v7.55h-3.952z" />
      </clipPath>
      <mask
        id="prefix__mask"
        x={7.55}
        y={22.331}
        width={3.953}
        height={7.551}
        maskUnits="userSpaceOnUse"
      >
        <path d="M7.55 22.331h3.953v7.551H7.55z" />
        <path fill="url(#prefix__linear-gradient)" d="M7.55 22.331h3.953v7.551H7.55z" />
      </mask>
      <mask
        id="prefix__mask-2"
        x={19.052}
        y={22.331}
        width={3.952}
        height={7.551}
        maskUnits="userSpaceOnUse"
      >
        <path d="M19.052 22.331h3.952v7.55h-3.952z" />
        <path fill="url(#prefix__linear-gradient-2)" d="M19.052 22.331h3.952v7.55h-3.952z" />
      </mask>
      <style>
        {
          '.prefix__cls-1{isolation:isolate}.prefix__cls-4{fill:none}.prefix__cls-5{fill:#415364}.prefix__cls-7{opacity:.39999}.prefix__cls-8{clip-path:url(#prefix__clip-path)}.prefix__cls-12{clip-path:url(#prefix__clip-path-5)}'
        }
      </style>
    </defs>
    <title>{isAuthenticated ? 'Aftur á yfirlit' : ''}</title>
    <g id="prefix__Layer_2" data-name="Layer 2">
      <g id="prefix__Layer_1-2" data-name="Layer 1">
        <path
          className="prefix__cls-5"
          d="M98.41 52.057h.744v-.533a1.49 1.49 0 011.681-1.644 2.397 2.397 0 01.792.117v.77h-.413c-.533 0-.854.166-.854.804v.486h1.267v.853h-1.267v5.335h-1.206V52.91h-.745zM101.727 59.37h.343c.557 0 .757-.273.757-.853v-6.46h.674c.46 0 .533.142.533.921v5.61a1.409 1.409 0 01-1.561 1.621 2.284 2.284 0 01-.746-.094zm1.006-8.686a.71.71 0 111.42 0 .71.71 0 01-1.42 0M109.191 57.56a2.322 2.322 0 01-1.846.756 1.759 1.759 0 01-1.94-1.846c0-1.266 1.005-1.882 2.4-1.882a5.135 5.135 0 011.35.167v-.818c0-.733-.426-1.052-1.243-1.052a2.85 2.85 0 00-1.692.51h-.379v-.9a4.734 4.734 0 012.225-.534c1.468 0 2.308.533 2.308 1.894v4.39h-.473c-.474 0-.639-.129-.71-.686m-.036-.78v-1.315a5.609 5.609 0 00-1.148-.119c-.828 0-1.42.308-1.42 1.055a1.013 1.013 0 001.148 1.088 1.796 1.796 0 001.42-.71m-1.432-5.242v-.284l.604-1.29h1.207v.39l-1.113 1.184zM113.317 53.726v4.52h-1.207v-6.188h.757c.296 0 .427.128.45.852a2.375 2.375 0 011.774-.912 1.07 1.07 0 01.331.047v.994s-.223-.012-.27-.012a2.722 2.722 0 00-1.835.699M117.85 52.814a3.67 3.67 0 012.212-.853 1.343 1.343 0 011.42.901 3.727 3.727 0 012.307-.9 1.427 1.427 0 011.54 1.644v4.64h-1.196v-4.319c0-.722-.307-.959-.875-.959a3.159 3.159 0 00-1.67.592v4.685h-1.206v-4.318c0-.722-.308-.959-.865-.959a3.08 3.08 0 00-1.667.592v4.685h-1.208v-6.188h.758c.296 0 .427.13.45.757M126.719 55.17a2.968 2.968 0 115.917 0 2.964 2.964 0 11-5.917 0m4.685 0c0-1.493-.673-2.298-1.726-2.298-1.042 0-1.728.805-1.728 2.297 0 1.49.686 2.237 1.728 2.237 1.053 0 1.726-.747 1.726-2.237m-3.384-4.46a.673.673 0 01.674-.665.663.663 0 110 1.326.672.672 0 01-.674-.662m1.976 0a.663.663 0 11.663.662.663.663 0 01-.663-.662M139.265 58.032c0 1.455-1.125 2.202-2.853 2.202a4.856 4.856 0 01-2.377-.52V58.8h.39a3.027 3.027 0 001.822.532c1.124 0 1.81-.39 1.81-1.383v-.663a2.587 2.587 0 01-1.904.804c-1.255 0-2.414-.829-2.414-2.934 0-2.319 1.301-3.196 2.603-3.196a2.454 2.454 0 011.798.675c.071-.33.237-.579.568-.579h.557zm-1.208-1.597v-2.959a1.909 1.909 0 00-1.419-.544c-.817 0-1.682.427-1.682 2.13 0 1.657.628 2.142 1.515 2.142a2.243 2.243 0 001.586-.769M142.239 52.838a3.94 3.94 0 012.366-.876c.864 0 1.587.354 1.587 1.704v4.58h-1.208V53.95c0-.769-.342-.982-.935-.982a3.711 3.711 0 00-1.81.615v4.662h-1.207v-6.188h.757c.295 0 .427.13.45.781M151.834 56.79v-4.733h1.208v6.188h-.757c-.285 0-.403-.094-.44-.698a3.989 3.989 0 01-2.234.781 1.481 1.481 0 01-1.694-1.657v-4.614h1.207V56.4c0 .792.39.981.959.981a3.592 3.592 0 001.75-.59M156.046 52.838a3.943 3.943 0 012.367-.876c.863 0 1.584.354 1.584 1.704v4.58h-1.207V53.95c0-.769-.343-.982-.933-.982a3.715 3.715 0 00-1.811.615v4.662h-1.207v-6.188h.758c.295 0 .425.13.449.781M53.268 41.502V11.231h8.304v24.563h11.89v5.708H53.268zM77.572 46.734l2.983-6.313-8.217-19.936v-1.772h7.396l4.756 12.931h.128l4.412-12.931h6.658v1.772l-11.07 28.021h-7.046v-1.772zM106.717 27.19l7.091-8.478h6.487v1.86l-6.268 7.136 7.135 11.935v1.86h-7.309l-5.277-8.866-1.859 2.03v6.836h-7.783V11.232h4.929c2.379 0 2.854.605 2.854 4.064zM125.219 13.697a4.037 4.037 0 018.04 0 4.041 4.041 0 01-8.04 0m.128 27.805v-22.79h5.018c2.333 0 2.724.778 2.724 4.37v18.42zM138.79 41.502v-30.27h4.928c2.422 0 2.854.605 2.854 4.063v26.207zM152.273 41.502v-30.27h4.93c2.423 0 2.854.605 2.854 4.063v26.207z"
        />
        <path
          d="M40.309 22.331H19.052V1.074A1.077 1.077 0 0017.981 0H1.074A1.078 1.078 0 000 1.074v27.734a1.073 1.073 0 001.066 1.074h10.437v10.5a1.111 1.111 0 001.073 1.113h27.733a1.08 1.08 0 001.076-1.075V23.405a1.078 1.078 0 00-1.076-1.074m-28.806 0H7.55V7.553h3.953zm22.33 11.612h-14.78v-4.062h14.78z"
          fill="#ffc629"
        />
        <g className="prefix__cls-7">
          <g className="prefix__cls-8">
            <g
              className="prefix__cls-8"
              mask="url(#prefix__mask)"
              clipPath="url(#prefix__clip-path-2)"
            >
              <path fill="url(#prefix__linear-gradient-3)" d="M7.55 22.331h3.953v7.551H7.55z" />
            </g>
          </g>
        </g>
        <g className="prefix__cls-7">
          <g className="prefix__cls-12">
            <g
              className="prefix__cls-12"
              mask="url(#prefix__mask-2)"
              clipPath="url(#prefix__clip-path-6)"
            >
              <path fill="url(#prefix__linear-gradient-4)" d="M19.052 22.331h3.952v7.55h-3.952z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Logo.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

export default Logo;
